<template>
  <div id="container">
    <div class="item-box-content" style="padding-right: 100px;">
      <div class="title-font-style">
        <span>添加汇票</span>
      </div>
      <el-form
        :model="listobj"
        style="padding:20px 20px 0 20px"
        label-width="100px"
        label-position="right"
        ref="formRefex"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="来源：">后台添加</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="承兑票号：" prop="billNumber" :rules="[{ required: true, message: '请填写承兑汇票', trigger:'blur' }]">
              <el-input v-model="listobj.billNumber" placeholder="请填写承兑汇票" style="width: 340px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="票据金额：" prop="billMoney" :rules="[{ required: true, message: '请输入票据金额' }]">
              <el-input-number v-model="listobj.billMoney" :controls="false" placeholder="请输入票据金额" style="width: 340px;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              style="padding-top:10px"
              label="出票单位："
              prop="billCompany"
              :rules="[{ required: true, message: '请填写出票单位' }]"
            >
              <el-input v-model="listobj.billCompany" placeholder="请填写出票单位" style="width: 340px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              style="padding-top:10px"
              label="出票行："
              prop="billBank"
              :rules="[{ required: true, message: '请填写出票行' }]"
            >
              <el-input v-model="listobj.billBank" placeholder="请填写出票行" style="width: 340px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              style="padding-top:10px"
              label="出票日期："
              prop="billDate"
              :rules="[{ required: true, message: '选择出票日期' }]"
              default-time
            >
              <el-date-picker
                style="width: 340px;"
                v-model="listobj.billDate"
                type="date"
                placeholder="选择出票日期"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              style="padding-top:10px"
              label="到期日期："
              prop="billEnddate"
              :rules="[{ required: true, message: '选择到期日期' }]"
            >
              <el-date-picker
                style="width: 340px;"
                v-model="listobj.billEnddate"
                type="date"
                :picker-options="pickerOptions"
                placeholder="选择到期日期"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="上传凭证：" prop="billAttachment">
<!--     /api/systemAttachment/uploadFinanceDraft       /api/systemAttachment/upload-->
            <el-upload
              :on-success="handleSuccess"
              :on-change="upload"
              :before-upload="berore"
              :before-remove="fileRemove"
              :on-exceed="fileExceed"
              :limit="1"
              drag
              style="width:100%;"
              name="MultipartFile[]"
              action="/api/systemAttachment/uploadFinanceDraft"
              multiple
              :file-list="fileList"
              :headers="onheader"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text" style="width:100%;">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
              <div slot="tip">只支持pdf、png、和jpeg，最多可上传6个附件不超过10M</div>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注：">
            <el-input type="textarea" v-model="listobj.mark" :rows="3"></el-input>
          </el-form-item>
        </el-row>
        <el-button type="primary" letter-spacing @click="submitBtn">提交</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import { addBill } from '@/api/fiance/fianceManage'
import { getCookie } from '../../../../../util/auth'
import { isSuccess } from '@/util/tool'
export default {
  data () {
    return {
      onheader: {
        Authorization: 'Bearer ' + getCookie('uToken')
      },
      guid: '',

      fileList: [],
      uploadFileType: ['pdf', 'png', 'jpeg'],
      listobj: {},
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },

  methods: {
    // 上传成功
    handleSuccess (response, file, fileList) {
      if (response.code === 200) {
        file.guid = (response.obj && response.obj[0].guid) || ''
      } else {
        this.$message.error('上传失败')
        fileList.splice(fileList.length - 1, 1)
      }
      this.fileList = fileList
    },
    upload () {
      return true
    },
    fileRemove () {
      return true
    },
    berore (file) {
      const { uploadFileType } = this
      const filearr = file.name.split('.')
      const filetype = filearr[filearr.length - 1]
      if (file.size === 0) {
        this.$message.error('文件内容为空')
        return false
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('文件过大')
        return false
      }
      if (uploadFileType.includes(filetype)) {
        return true
      }
      this.$message.error('请上传正确的文件')
      return false
    },
    fileExceed () {
      this.$message.error('最多只能上传一个凭证')
    },
    submitBtn () {
      const { fileList } = this
      this.listobj.billAttachment = fileList.map(item => item.guid || '').join(',')
      this.listobj.fromType = 1
      this.$refs.formRefex.validate(vaild => {
        if (vaild) {
          addBill(this.listobj)
            .then((res) => {
              if (isSuccess(res)) {
                this.$router.push('acceptDraftManage')
                this.$message.success('添加成功')
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.onlond {
  margin-left: -10px;
  padding: 2px;
}
.monery {
  margin: -10px 0px;
}
.lets {
  padding-left: 50px;
  margin-top: 40px;
}
.mark {
  padding-left: 10px;
  margin-top: -20px;
}
.upload-demo {
  margin-top: -20px;
}
/deep/.el-upload-dragger {
  height: 80px;
}
/deep/.el-upload-dragger .el-icon-upload {
  margin: 2px 0 10px 0;
}
/deep/.el-upload-dragger .el-upload__text {
  line-height: 0;
}
/deep/.el-upload-dragger .el-icon-upload {
  font-size: 50px;
}

/deep/ .el-upload-dragger {
  width: 100%;
}
/deep/ .el-upload {
  width: 100%;
}
/deep/.el-input--mini {
  width: 100%;
}
</style>
